/** @file editTarget: the stored clip and frame a viewport edit writes, or why it may not (toast). */
import type { Clip } from '@zilo/pose3d-format/types/clip';
import type { EditorActions, EditorState } from '../../state/editorTypes';
import { mirrorGuard } from '../timeline/mirrorGuard';

/**
 * The playhead's clip in the document and the playhead frame; null (with a warning toast) without a document or
 * clip, or on the mirrored half of a `mirrorHalf` clip (`mirrorGuard`, the same rule as the timeline and inspector:
 * keys there would be ignored, plan Review Focus 3).
 */
export function editTarget(s: EditorState & Pick<EditorActions, 'notify'>): { clip: Clip; frame: number } | null {
  const name = s.playhead.clip;
  const clip = name === null ? undefined : s.puppet.doc?.clips[name];
  if (clip === undefined) { s.notify('warning', 'Pick a clip on the timeline before posing.'); return null; }
  const frame = s.playhead.frame;
  return mirrorGuard(clip, frame, s.notify) ? null : { clip, frame };
}
